export type TWeightedConfig<T extends string | number> = Record<T, number>;

export interface IWeightedItem<T> {
    value: T;
    cumulative: number;
}

export class WeightedBag<T extends string | number> {
    private readonly items: IWeightedItem<T>[] = [];
    private readonly totalWeight: number = 0;

    constructor(config: TWeightedConfig<T>) {
        for (const [value, weight] of Object.entries(config) as [T, number][]) {
            const w = Number(weight);
            if (w <= 0) continue;

            this.totalWeight += w;

            this.items.push({
                value,
                cumulative: this.totalWeight
            });
        }
    }

    draw(): T {
        if (this.totalWeight === 0) throw new Error('Cannot draw item from weighted bag due to wrong weights: ');

        const r = Math.random() * this.totalWeight;

        for (const item of this.items) {
            if (r < item.cumulative) {
                return item.value;
            }
        }

        throw new Error('Cannot draw item from weighted bag due to wrong values: ');
    }
}
